import React, { useEffect, useState } from "react";
import AddRoomType from "./AddRoomType";
import { getRoomTypes } from "../../apis/room";
import { Pagination, PaginationProps } from "antd";
import CommonPagination from "../../components/CommanPagination";
import { Button, Dropdown } from "antd";
import { useNavigate } from "react-router-dom";

const RoomTypes = () => {
  const [openModal, setOpenModal] = useState(false);
  const [roomTypes, setRoomTypes] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [meta, setMeta] = useState<any>();
  const navigate = useNavigate();
  const [editingRoomTypeId, setEditingRoomTypeId] = useState<number | undefined>(undefined);

  useEffect(() => {
    fetchRoomTypes({ page: 1, per_page: 10 });
  }, []);

  const fetchRoomTypes = async (params: any = { page: 1, per_page: 10 }) => {
    setLoading(true);
    try {
      const res: any = await getRoomTypes(params);
      
      setRoomTypes(res?.data || []);
      // setMeta(res.meta || {}); 
      setMeta({
        currentPage: params.page,
        perPage: params.per_page,
        total: res.data.length,
      });

    } catch (error) {
      console.error("Failed to fetch room types", error);
    } finally {
      setLoading(false);
    }
  };

  const getRoomTypeStatus = (rooms: any[] = []) => {
  if (rooms.length === 0) return "No Rooms";

  if (rooms.some(r => r.status === "available")) return "Available";
  if (rooms.some(r => r.status === "occupied")) return "Occupied";

  return "Maintenance";
};

const onPaginationChange = (page: number, pageSize?: number) => {
  fetchRoomTypes({ page, per_page: pageSize || 10 }); 
};

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center sm:justify-between">
        <div>
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Room Types List
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            List of all room types.
          </p>
        </div>

        <div className="flex gap-3">
          <button
            className="px-3 py-2 text-sm font-semibold text-white rounded-md bg-primary hover:bg-hover"
            onClick={() => setOpenModal(true)}
          >
            Add Room Type
          </button>
        </div>
      </div>

      <AddRoomType
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          setEditingRoomTypeId(undefined);
          fetchRoomTypes();
        }}
        roomTypeId={editingRoomTypeId}
        roomTypeData={roomTypes.find(r => r.id === editingRoomTypeId)}
      />

      <div className="flow-root mt-8">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold">
                      Type Name
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold">
                      Price / Hour (₹)
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold">
                      Price / Day (₹)
                    </th>
                    <th className="py-3.5 px-3 text-left text-sm font-semibold">
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody className="bg-white divide-y divide-gray-200">
                  {loading ? (
                    <tr>
                      <td colSpan={5} className="py-4 text-center">
                        Loading...
                      </td>
                    </tr>
                  ) : roomTypes.length === 0 ? (
                    <tr>
                      <td colSpan={5} className="py-4 text-center">
                        No room types found
                      </td>
                    </tr>
                  ) : (
                    roomTypes.map((type) => {
                      const status = getRoomTypeStatus(type.rooms);

                      return (
                        <tr key={type.id}>
                          <td className="py-4 px-3 text-sm font-semibold">
                            {type.name}
                          </td>

                          <td className="py-4 px-3 text-sm">
                            {type.pricePerHour}
                          </td>

                          <td className="py-4 px-3 text-sm">
                            {type.pricePerDay}
                          </td>

                          <td className="py-4 px-3 text-sm text-gray-700">
                            <Dropdown
                              menu={{
                                items: [
                                  {
                                    key: "edit",
                                    label: (
                                      <span
                                        onClick={() => {
                                          setEditingRoomTypeId(type.id);
                                          setOpenModal(true);
                                        }}
                                        className="cursor-pointer"
                                      >
                                        Edit
                                      </span>
                                    ),
                                  },
                                ],
                              }}
                              placement="bottomLeft"
                            >
                              <Button>Actions</Button>
                            </Dropdown>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
            <CommonPagination meta={meta} onChange={onPaginationChange} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoomTypes;
